import { render, staticRenderFns } from "./BaseRadioButtonNew.vue?vue&type=template&id=6c3b943f&scoped=true"
import script from "./BaseRadioButtonNew.vue?vue&type=script&lang=js"
export * from "./BaseRadioButtonNew.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioButtonNew.vue?vue&type=style&index=0&id=6c3b943f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b943f",
  null
  
)

export default component.exports